import React, { useContext } from 'react';
import navbarLinks from '../../../Data/navbarLinks.js';
import { Link, useNavigate } from 'react-router-dom';
import { getUserFromLocalStorage } from '../../../utils/localStorage';
import { AppConfigContext } from '../../../Config/App';
import { LanguageContext } from '../../../Data/Context/languageContext.js';
import DropDownDark from '../../../Components/dropdown/dropdownDark.jsx';
import dropDownList from '../../../Components/dropdown/languages.json';
import uuid from 'uuidv4';
import { logOut } from '../../../features/user/userSlice.js';

const NavbarLinks = () => {
    const user_session = getUserFromLocalStorage();
    const navigate = useNavigate();
    const { navigate_to } = useContext(AppConfigContext);
    const { t } = useContext(LanguageContext);

    const dashboard = () => {
        navigate(navigate_to('dashboard'));
    }

    const auth = () => {
        navigate(navigate_to('auth'));
    }

    const logout_user = () => {
        navigate(navigate_to());
        logOut(t("toast_logged_out"));
    }

    const links = navbarLinks.map((data, index) => {
        if (data.href === "new-build" && !user_session) {
            return (
                <span key={uuid()}>
                    <li className="nav-item d-none d-lg-flex" data-bs-toggle="modal" data-bs-target="#login-modal">
                        <span className={`nav-link`} href="">
                            {t(data.text)}
                        </span>
                    </li>

                    <Link onClick={auth} className={`nav-link d-lg-none`} to={navigate_to('auth')} data-bs-dismiss="offcanvas">
                        {t(data.text)}
                    </Link>
                </span>
            )
        }
        return (
            <span key={uuid()}>
                <li className="nav-item d-none d-lg-flex">
                    <Link className={`nav-link`} to={navigate_to(`${data.href}`)}>
                        {t(data.text)}
                    </Link>
                </li>

                <li className="nav-item d-lg-none" data-bs-dismiss="offcanvas">
                    <Link className={`nav-link`} to={navigate_to(`${data.href}`)}>
                        {t(data.text)}
                    </Link>
                </li>
            </span>
        )
    })

    return (
        <ul className="navbar-nav">
            {links}

            {user_session &&
                <Link onClick={logout_user} className={`nav-link`} to={navigate_to()} data-bs-dismiss="offcanvas">
                    {t("sign_out")}
                </Link>
            }

            <DropDownDark classes="dropdown my-4 d-lg-none" changeLanguage={true} buttonText="English" dropDownList={dropDownList} />
            {user_session
                ?
                <>
                    <li className="nav-item me-sm-5 me-md-3 d-none d-lg-flex">
                        <Link onClick={dashboard} className={`nav-link box`} to={navigate_to('dashboard')}>
                            {t("user_dashboard")}
                        </Link>
                    </li>

                    <li className="nav-item me-sm-5 me-md-3 d-lg-none" data-bs-dismiss="offcanvas">
                        <Link onClick={dashboard} className={`nav-link box`} to={navigate_to('dashboard')}>
                            {t("user_dashboard")}
                        </Link>
                    </li>
                </>
                :
                <>
                    <li className="nav-item me-sm-5 me-md-3 d-none d-lg-flex">
                        <Link className={`nav-link box`} to={navigate_to('auth')}>
                            {t("menu_login")}
                        </Link>
                    </li>

                    <li className="nav-item me-sm-5 me-md-3 d-block d-lg-none" data-bs-dismiss="offcanvas">
                        <Link className={`nav-link box`} to={navigate_to('auth')}>
                            {t("menu_login")}
                        </Link>
                    </li>
                </>
            }
        </ul>
    )
}
export default React.memo(NavbarLinks);